export const WIN_TYPES: string[] = [
    'WinType1',
    'WinType2',
    'WinType3',
    'WinType4',
    'WinType5',
    'WinType6',
    'BigWinX20',
    'BigWinX50',
    'BigWinX100'
];